export var ArcGisStreetColumn;
(function (ArcGisStreetColumn) {
    ArcGisStreetColumn["Id"] = "OBJECTID";
    ArcGisStreetColumn["Name"] = "Name";
    ArcGisStreetColumn["AlternativeName"] = "Place";
    ArcGisStreetColumn["Area"] = "Area";
    ArcGisStreetColumn["Place"] = "AlternativeName";
    ArcGisStreetColumn["Type"] = "Type";
    ArcGisStreetColumn["Ward"] = "Ward";
})(ArcGisStreetColumn || (ArcGisStreetColumn = {}));
